const getters = {
    users: (state) => state.users,
    usersId: (state) => state.usersId,
    role: (state) => state.role,
    loading: state => state.loading
};

export default getters;